import { z } from 'zod';

// ---------------------------------------------------------------------------
// Live Update Navigation
// ---------------------------------------------------------------------------

// User-facing nav values only. `chat_task` is an internal cache-sharing
// fetch mode (never a persisted nav state), so it is intentionally excluded.
export const navItemSchema = z.enum(['chat', 'support', 'task']);

export const hubCountResetBody = z.object({
  hub_id: z.string().uuid(),
  nav_item: navItemSchema,
  conversation_id: z.string().uuid().optional(),
  hub_user_id: z.string().optional(),
  current_team_user_id: z.string().optional(),
});

export const navItemCountResetBody = z.object({
  nav_item: navItemSchema,
});

// ---------------------------------------------------------------------------
// Typing Indicator
// ---------------------------------------------------------------------------

export const typingBody = z.object({
  conversationId: z.string().uuid(),
  hubId: z.string().uuid(),
  action: z.enum(['start', 'stop']),
});

// ---------------------------------------------------------------------------
// Inferred types
// ---------------------------------------------------------------------------

export type HubCountResetBody = z.infer<typeof hubCountResetBody>;
export type NavItemCountResetBody = z.infer<typeof navItemCountResetBody>;
export type TypingBody = z.infer<typeof typingBody>;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface NavigationCounts {
  chat_count: number;
  support_count: number;
  task_count: number;
}

/** GET /counts */
export interface GetNavigationCountsResponse {
  success: true;
  data: NavigationCounts;
}

/** POST /reset-hub */
export interface ResetHubCountResponse {
  success: true;
  message: string;
  updated: boolean;
}

/** POST /reset-nav */
export interface ResetNavItemCountResponse {
  success: true;
  message: string;
}

/** POST /typing */
export interface TypingResponse {
  success: true;
}
